import React, { useLayoutEffect, useRef, useState } from 'react';

// Measure the host, including nested grids. Viewport width and track position
// do not determine a layout's available space.
export default function ResponsiveColumns({ columns, gap, style, children, ...props }) {
  const ref = useRef(null);
  const [stacked, setStacked] = useState(false);
  useLayoutEffect(() => {
    const element = ref.current;
    const measure = () => {
      const width = element.clientWidth - 2 * (parseFloat(style.padding) || 0);
      setStacked(width > 0 && width < columns * 160 + Math.max(0, columns - 1) * gap);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [columns, gap, style.padding]);
  return <div {...props} ref={ref} data-kea-stacked={stacked ? 'true' : 'false'}
    style={{ ...style, ...(stacked ? { gridTemplateColumns: 'minmax(0, 1fr)' } : {}) }}>
    {children}
  </div>;
}
